
<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-secondary text-white">
        <b>Request For Transport Certificate :</b>
      </div> -->
       <div  class="p-3 mb-2">
        <h4 style="text-align: left">Transport Certificate
            <b-button class="float-right"  variant="danger" @click="handleBack">Back</b-button>
        </h4>
        
          
        <hr/>
      </div>
      <!-- <html>
<head>
  <title>Register Form</title>
</head>
<body> -->
      <form>
        <table>
          <tr>
            <td>Requester :</td>
            <td><input type="text" disabled/></td>
          </tr>
          <tr>
            <td>Contact no :</td>
            <td>
            
              <input type="phone" disabled />
            </td>
          </tr>

          <tr>
            <td>Start Date :</td>
            <td><input type="text" disabled/></td>
          </tr>
          <tr>
            <td>End Date :</td>
            <td><input type="text" disabled /></td>
          </tr>

          <tr>
            <td>Vehicle No :</td>
            <td><input type="number" disabled/></td>
          </tr>
          <tr>
            <td>Vehicle Type :</td>
            <td><input type="text" disabled /></td>
          </tr>
          <tr>
            <td>Transport From :</td>
            <td><input type="text" disabled /></td>
          </tr>
          <tr>
            <td>Transport To :</td>
            <td><input type="text" disabled /></td>
          </tr>
          <tr>
            <td>Driver Name :</td>
            <td><input type="text" disabled /></td>
          </tr>
          <td></td>
        </table>
       
      </form>
      <td></td>
      <b-table
        show-empty
        empty-text="No Records Available"
        stacked="xs"
        bordered
        striped
        :items="item"
        :fields="fields"
        style="font-size: 12px"
      >
      </b-table>
      
      <button variant="primary" @click="handleSubmit">
      Approve
      </button>&nbsp;
      <button variant="primary" @click="handleSubmit1">
        Reject
      </button>

      <!-- </body>
</html> -->
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";
import DatePicker from "vue2-datepicker";
//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {
  components: { DatePicker },
  data() {
    return {
      Observations: "",
      item: [
         { Tag_name: 40, type_name: 'Dickerson', is_medical: 'Yes' },
          {Tag_name: 21, type_name: 'Larsen', is_medical: 'No' },
          { Tag_name: 89, type_name: 'Geneva', is_medical: 'Pending' },
      ],
      fields: [
        { key: "Tag_name", label: "Tag No", sortable: true },
        { key: "type_name", label: "Type", sortable: true },
        // {
        //   key: "employee_category",
        //   label: "Employee Category",
        //   sortable: true,
        // },
        { key: "is_medical", label: " Medical Certificate" },
      ],
    };
  },
  computed: {},
  methods:  {
    handleSubmit() {
      alert("Approval Success");
    },
    handleSubmit1() {
      alert("Reject Success");
    },
  
    reset_details() {
      this.Observations = "";
    },
    handleBack(){
            this.$router.go(-1);
        },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;

  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
